export const alertOverrides = {
  icon: () => ({
    marginRight: 8,
    fontSize: 20,
  }),
};
